var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2145 12.3535L9.15664 8.2957C9.78633 7.48164 10.127 6.48633 10.127 5.43945C10.127 4.18633 9.63789 3.01133 8.75352 2.12539C7.86914 1.23945 6.69102 0.751953 5.43945 0.751953C4.18789 0.751953 3.00977 1.24102 2.12539 2.12539C1.23945 3.00977 0.751953 4.18633 0.751953 5.43945C0.751953 6.69102 1.24102 7.86914 2.12539 8.75352C3.00977 9.63945 4.18633 10.127 5.43945 10.127C6.48633 10.127 7.48008 9.78633 8.29414 9.1582L12.352 13.2145C12.3639 13.2264 12.378 13.2358 12.3935 13.2422C12.4091 13.2487 12.4257 13.252 12.4426 13.252C12.4594 13.252 12.4761 13.2487 12.4916 13.2422C12.5072 13.2358 12.5213 13.2264 12.5332 13.2145L13.2145 12.5348C13.2264 12.5229 13.2358 12.5087 13.2422 12.4932C13.2487 12.4776 13.252 12.461 13.252 12.4441C13.252 12.4273 13.2487 12.4106 13.2422 12.3951C13.2358 12.3795 13.2264 12.3654 13.2145 12.3535ZM7.91445 7.91445C7.25195 8.57539 6.37383 8.93945 5.43945 8.93945C4.50508 8.93945 3.62695 8.57539 2.96445 7.91445C2.30352 7.25195 1.93945 6.37383 1.93945 5.43945C1.93945 4.50508 2.30352 3.62539 2.96445 2.96445C3.62695 2.30352 4.50508 1.93945 5.43945 1.93945C6.37383 1.93945 7.25352 2.30195 7.91445 2.96445C8.57539 3.62695 8.93945 4.50508 8.93945 5.43945C8.93945 6.37383 8.57539 7.25352 7.91445 7.91445Z",
    fill: "#333333",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2a77f1ba4ca67a8e3cd417d4849aed2c.svg";
export { ForwardRef as ReactComponent };